import { url } from "./misc";
import Cookies from 'js-cookie';

export async function apiKeyCheck(tenant) {
    const endpoint = url + "/api/hetzner/servers/list"
    const JWT = Cookies.get('CF_Authorization');

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'tenant': tenant,
        }
    };

    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response;
};

export async function getServerPlans(tenant) {
    const endpoint = url + "/api/hetzner/servers/list"
    const JWT = Cookies.get('CF_Authorization');
    // Define the request parameters
    const requestData = {
    };

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'tenant': tenant,
        },
        body: JSON.stringify(requestData),
    };

    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response;

};

export async function getDatacenters(tenant) {
    const endpoint = url + "/api/hetzner/datacenters/list"
    const JWT = Cookies.get('CF_Authorization');
    // Define the request parameters
    const requestData = {
    };

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'tenant': tenant,
        },
        body: JSON.stringify(requestData),
    };

    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response;

};